export default {
  disasterAvoidPolygons: {
    name: 'Nom',
    description: 'Description',
    disasterType: 'Type de catastrophe',
    disasterSubType: 'Sous-type de catastrophe',
    fillRequiredFields: 'Veuillez remplir les champs requis pour la zone sinistrée',
    avoidAreaSaved: 'Zone sinistrée sauvée',
    avoidAreaDeleted: 'Zone sinistrée supprimée',
    fillAreaProperties: 'Remplissez les propriétés de la zone à éviter et enregistrez-la',
    editProperties: 'Modifier les propriétés',
    createADisasterPolygon: 'Créer un polygone de catastrophe',
    createADisasterRectangle: 'Créer un rectangle de catastrophe',
    errorWhileTryingToSaveDisasterArea: 'Erreur lors de la tentative de sauvegarde de la zone sinistrée',
    authorizationError: 'Erreur d\'autorisation. Veuillez vous assurer que la clé que vous avez saisie est valide. Pour saisir à nouveau la clé, rechargez l\'application',
    disasterAreaUsageInfo: 'Vous pouvez: déplacer la vue cartographique pour charger les zones sinistrées d\'une région cible, utiliser les outils de dessin de polygone pour créer de nouvelles zones sinistrées et cliquer sur une zone sinistrée pour la modifier',
    errorCodes: {
      2404: 'Le fournisseur n\'existe pas',
      3404: 'Le type de sinistre n\'existe pas',
      5409: 'Nom de la zone sinistrée déjà utilisé'
    },
    statuses: {
      401: 'Non autorisé',
    }
  }
}
